function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -540.36)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "black",
  fill: "current",
  d: "M461.713,683.993l-74.7-107.4c-1-1.5-2.5-2.6-4.3-3l-99.6-25c-0.6-0.1-1.2-0.2-1.8-0.2h-7.5c-2.7,0-5.2,1.4-6.5,3.7 c-7.6,13.1-21.3,21.2-35.8,21.2c-15.5,0-29.4-7.9-37.1-21.2c-1.4-2.3-3.8-3.7-6.5-3.7h-6.2c-0.6,0-1.2,0.1-1.8,0.2l-99.6,25 c-1.7,0.4-3.3,1.5-4.3,3l-74.7,107.4c-2,2.9-1.7,6.9,0.8,9.5l49.8,51.2c1.4,1.5,3.4,2.3,5.4,2.3s4-0.8,5.4-2.3l19.4-20.3v263.5 c0,4.1,3.4,7.5,7.5,7.5h282.5v0c4.2,0,7.5-3.4,7.6-7.5v-264.5l20.9,20.2c2.9,2.8,7.6,2.8,10.5-0.1l49.8-49.9 C463.413,690.993,463.813,686.993,461.713,683.993z M405.613,727.593l-28.3-27.3c-2.1-2.1-5.3-2.7-8.1-1.5 c-2.8,1.2-4.6,3.9-4.6,6.9v274.7h-267.4v-274.7c0-3.1-1.9-5.9-4.7-7c-2.8-1.1-6.1-0.4-8.2,1.8l-27,28.1l-40.1-41.2l69.5-100 l95.9-24.1h1.2c10.7,15.5,28.6,25,47.7,25c18.3,0,35.8-9.5,46.4-25h2.4l95.9,24.1l69.5,99.9L405.613,727.593z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M322.413,648.294h-33.6c-4.1,0-7.5,3.4-7.5,7.5v32.5c0,1.1,0.3,2.3,0.8,3.3c2.5,5,11.7,21.6,24.1,21.6 c10.9,0,19.6-15.1,22.9-21.6c0.5-1,0.8-2.1,0.8-3.3v-32.5C329.913,651.694,326.513,648.294,322.413,648.294z M314.813,686.393 c-2.8,5.3-6.8,10.5-8.9,11.7c-2.3-0.8-6.7-6.2-9.7-11.7v-23.1h18.6V686.393z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M201.013,765.094c-2.6-1.2-5.8-0.8-8,1.1l-33.6,28.7c-3.1,2.7-3.5,7.5-0.8,10.6s7.5,3.5,10.6,0.8l21.2-18.1v117.3 c0,4.1,3.4,7.5,7.5,7.5v0c4.1,0,7.5-3.4,7.5-7.5v-133.6C205.413,768.994,203.713,766.294,201.013,765.094z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M284.413,765.094c-2.6-1.2-5.8-0.8-8,1.1l-33.6,28.7c-3.1,2.7-3.5,7.5-0.8,10.6s7.4,3.5,10.6,0.8l21.2-18.1v117.3 c0,4.1,3.4,7.5,7.5,7.5l0,0c4.1,0,7.5-3.4,7.5-7.5v-133.6C288.813,768.994,287.113,766.294,284.413,765.094z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgJersey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 463.067 463.067",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJersey);
export default __webpack_public_path__ + "static/media/jersey.839daec3.svg";
export { ForwardRef as ReactComponent };